/**
 * @file formatBytes.ts
 * @description Formats a byte count as a short human-readable size. Consumers:
 * `AttachmentList` for the file row's size column, `AttachmentVersionRow` for one
 * listed version's size, and `resolveAttachmentTransferCaption` for a transfer's
 * byte figures.
 *
 * Falsy and zero inputs both read as `'0 Bytes'`. The two panel call sites guard
 * on the size first and render nothing when it is absent; the caption does not,
 * because a transfer that has moved nothing yet must still print a figure. The
 * unit and the number are not separated by a space, which is what the panel has
 * always shown.
 */

/**
 * Formats bytes into a human-readable string.
 */
export const formatBytes = (bytes: number, decimals = 2): string => {
    if (!+bytes || bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))}${sizes[i]}`;
};
